export const modalConstants = {
  SHOW: 'MODAL_SHOW',
  CLEAR: 'MODAL_CLEAR',
}
